<template>
  <div class="findMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <van-cell-group class="forestInput" v-if="!showNonePage">
      <van-field
        v-model="baseData.title"
        readonly
        :label="$t('common.name') + '：'"
      />
      <van-field
        v-model="baseData.discoverTypeName"
        readonly
        :label="$t('common.type') + '：'"
      />
      <van-field
        v-model="baseData.creatorName"
        readonly
        :label="$t('findMsg.creatorTit') + '：'"
      />
      <van-field
        v-model="baseData.createTime"
        readonly
        :label="$t('findMsg.createTime') + '：'"
      />
      <van-field
        v-model="baseData.remarks"
        rows="3"
        autosize
        type="textarea"
        readonly
        :label="$t('findMsg.remarks') + '：'"
      />
    </van-cell-group>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "findMsg",
  data() {
    return {
      showNonePage: true,
      findId: "",
      baseData: {},
      refreshPage: false, //网络失败
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "发现信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.findId = this.$route.query.commonId;
      if (this.findId == undefined) {
        this.findId = this.param.id;
      }
      this.initPage();
    });
  },
  components: {
    refreshPage,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .findMsg({
          objid: _this.findId,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.findId = _this.param.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.findMsgPage {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #f6f6f6;
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
}
</style>